// extracted by mini-css-extract-plugin
module.exports = {"loading":"main_loading___rnGI"};